module.exports = __webpack_public_path__ + "static/media/icon-dashboard.3d11253f.png";